import { render, staticRenderFns } from "./TaskLogDialog.vue?vue&type=template&id=25aaadd6"
import script from "./TaskLogDialog.vue?vue&type=script&lang=js"
export * from "./TaskLogDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskLogDialog.vue?vue&type=style&index=0&id=25aaadd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports